import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { ConfiguracaoFamiliaOrcamento } from "../../models/configuracao-familia-orcamento";
import { ItemPedido } from "../../models/pedido";
import { Marca } from "../../models/marca";
import { Filtro } from "../../models/filtro";
import { BehaviorSubject, Subscription } from "rxjs";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, PageEvent } from "@angular/material";
import { ProdutoService } from "../../services/produto.service";
import { UtilitarioService } from "../../services/utilitario.service";
import { CarregandoService } from "../../services/carregando.service";
import { NotificacaoService } from "../../services/notificacao.service";
import { MarcaService } from "../../services/marca.service";
import { PaginatorService } from "../../services/paginator.service";
import { CategoriaService } from "../../services/categoria.service";
import { Produto } from "../../models/produto";
import { DetalheProdutoModalComponent } from "../detalhe-produto-modal/detalhe-produto-modal.component";
import { Categoria } from "../../models/categoria";

declare const $: any;

@Component({
  selector: 'app-seleciona-produto-v2-modal',
  templateUrl: './seleciona-produto-v2-modal.component.html',
  styleUrls: ['./seleciona-produto-v2-modal.component.scss']
})
export class SelecionaProdutoV2ModalComponent implements OnInit {

  private alterouAbaSubscription: Subscription;
  categorias: Categoria[] = [];

  semKit = false;
  semPainel = false;
  semInversor = false;

  itensFiltrados: ItemPedido[] = [];
  marcaSelecionada: number;
  marcas: Marca[];

  categoria = 2;

  tipo: string;
  carregando = true;
  ordenarDesc = false;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroDescricao: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtros: Filtro[] = [this.filtroDescricao];
  campoOrdenacao = 'checado';

  categoriaExclusiva;

  public alterouAbaSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<SelecionaProdutoV2ModalComponent>,
    private produtoService: ProdutoService,
    public utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private marcaService: MarcaService,
    private paginatorService: PaginatorService,
    private categoriaService: CategoriaService
  ) {
    this.semKit = data.semKit;
    this.semPainel = data.semPainel;
    this.semInversor = data.semInversor;
    this.categoriaExclusiva = data.categoriaExclusiva;
  }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    await this.buscarCategorias();

    this.listarMarcas();

    this.alterouAbaSubscription = this.alterouAbaSubject.subscribe((dados: any) => {
      this.listarMarcas();
      this.buscarProdutos();
    });
  }

  async buscarCategorias(): Promise<void> {
    this.carregandoService.mostra('buscaCategorias');

    try {
      const data = await this.categoriaService.listar().toPromise();

      this.categorias = (data || [])
        .map(categoria => {
          let visivel;
          let habilitaVisualizacao: boolean;

          if (this.categoriaExclusiva) {
            visivel = categoria.id === this.categoriaExclusiva;
          } else {
            const mostraKit = !(this.semKit && categoria.id === 7);
            const mostraInversor = !(this.semInversor && categoria.id === 3);
            const mostraPainel = !(this.semPainel && categoria.id === 2);

            habilitaVisualizacao = mostraKit && mostraInversor && mostraPainel;
            visivel = habilitaVisualizacao;
          }

          return { ...categoria, visivel };
        })
        .filter(categoria => categoria.visivel);
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaCategorias');
    }
  }

  alterouTab(index) {
    this.ativaAba(Number(this.categorias[index].id));
  }

  ativaAba(cat) {
    this.categoria = cat;
    this.alterouAbaSubject.next({ categoria: this.categoria });
  }

  fechar() {
    this.dialogRef.close();
  }

  listarMarcas() {
    this.carregandoService.mostra('buscaMarcas');

    this.marcaService.listarPorCategoria(Number(this.categoria)).subscribe(
      (marcs) => {
        this.marcas = marcs;
        this.carregandoService.esconde('buscaMarcas');
      },
      (erro) => {
        this.carregandoService.esconde('buscaMarcas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarProdutos() {
    this.carregandoService.mostra('buscaProduto' + this.tipo);
    this.carregando = true;

    this.produtoService.consultarComPaginacao(
      this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.filtroDescricao.Valor, '', 'A', null,
      true, null, this.marcaSelecionada, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, 'A', null, this.categoria
    ).subscribe(dados => {

      const produtos: Produto[] = dados.itens;
      this.itensFiltrados = [];

      produtos.forEach(p => {
        const novoItem = new ItemPedido();
        novoItem.pUnitario = p.precoVenda;
        novoItem.pCusto = p.precoCusto;
        novoItem.produto = p.idProduto;
        novoItem.produtoTela = p;
        novoItem.det1 = p.descricaoAtual;

        this.itensFiltrados.push(novoItem);
      });

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscaProduto' + this.tipo);
    }, (erro) => {
      this.carregandoService.esconde('buscaProduto' + this.tipo);
    });
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarProdutos();
  }

  detalhesDoProduto(produto: Produto) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(DetalheProdutoModalComponent, {
      width: (($('body').width()).toString() + 'px'),
      // passa os produtos já selecionados
      data: {
        produto: produto
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  filtra() {
    this.buscarProdutos();
    this.paginator.firstPage();
  }

  selecionaProduto(produto: any) {
    this.dialogRef.close(produto);
  }

}
